import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { OrderField } from '@/@vxapp/@Enums/PHP/ServicesV2/Orders/DataProviders/OrderField'

export const OrdersTableActions = [
  {
    id: 'mark-inactive',
    title: 'Mark Inactive',
    tooltip: 'Mark Order as Inactive',
    icon: 'tabler-edit-off',
    color: 'secondary',
    disabled: false,
    hidden: false,
    emit: 'mark-inactive',
  },
  {
    id: 'preview',
    title: PageMeta.Orders.Preview.Title,
    icon: PageMeta.Orders.Preview.Icon,
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Orders.Preview.Name || '',
      paramKey: 'guid',
      itemKey: OrderField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
  {
    id: 'service',
    title: PageMeta.Orders.Service.Title,
    icon: PageMeta.Orders.Service.Icon,
    color: 'success',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Orders.Service.Name || '',
      paramKey: 'guid',
      itemKey: OrderField.DB_IDENTIFIER,
    },
    emit: 'service',
  },
  {
    id: 'messages-drawer',
    title: 'Messages Drawer',
    tooltip: 'Open Messages Drawer',
    icon: 'tabler-send',
    color: 'info',
    disabled: false,
    hidden: false,
    emit: 'messages-drawer',
  },
] as const satisfies readonly TableActionSpec[]
